import React, { createContext, useContext, useEffect, useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

const BrandContext = createContext({
  config: null,
  loaded: false,
  refresh: () => {},
});

export function resolveMediaUrl(url) {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('/uploads')) return `${BACKEND_URL}${url}`;
  return url;
}

export function BrandProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/public/config`);
      if (!response.ok) throw new Error('config');
      const data = await response.json();
      setConfig(data);
    } catch (error) {
      console.error('Errore caricamento configurazione brand:', error);
      setConfig({
        companyName: 'Azienda',
        primaryColor: '#1f4e79',
        secondaryColor: '#00a3a1',
        fontFamily: 'Montserrat, sans-serif',
        welcomeMessage: 'Ciao! Come posso aiutarti?',
        brandSttAliases: [],
      });
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <BrandContext.Provider value={{ config, loaded, refresh }}>
      {children}
    </BrandContext.Provider>
  );
}

export function useBrand() {
  return useContext(BrandContext);
}
